import IconButton from '@mui/material/IconButton'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import type { GridColDef } from '@mui/x-data-grid-premium'

import { UserRow } from './index'

export default function createColumns( confirmDeleteUser: ( user: UserRow ) => void ): GridColDef<UserRow>[] {
	return [
		{
			field: 'fullName',
			headerName: 'User',
			width: 200,
		},
		{
			field: 'actions',
			headerName: '',
			width: 96,
			align: 'center',
			headerAlign: 'center',
			renderCell: ( params ) => (
				<IconButton
					size="small"
					aria-label="Remove"
					title="Remove user"
					onClick={() => confirmDeleteUser( params.row )}
				>
					<DeleteOutlineIcon fontSize="small" />
				</IconButton>
			),
		},
	]
}
